import { render, staticRenderFns } from "./tbTable.vue?vue&type=template&id=ceb561f4&scoped=true"
import script from "./tbTable.vue?vue&type=script&lang=ts"
export * from "./tbTable.vue?vue&type=script&lang=ts"
import style0 from "./tbTable.vue?vue&type=style&index=0&id=ceb561f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb561f4",
  null
  
)

export default component.exports